import { IHttpAPI, HttpAppRequest, IHttpResponse } from '../core/http'
import {
  IUserAPIUtilsComplaintPayload,
  IUserAPIUtilsComplaintResponse,
} from '../user/userReport.api.types'
import { AuthResponseError } from '../auth/authError.service'

export class UserReportApi extends HttpAppRequest implements IHttpAPI {
  async reportPOST(payload: IUserAPIUtilsComplaintPayload) {
    const url = this.createURL('utils/complaint')

    const formData = new FormData()
    formData.append('type_id', payload.typeId.toString())
    formData.append('place_id', payload.placeId.toString())
    formData.append('user_id', payload.userId.toString())
    formData.append('photo_id', payload.photoId.toString())
    formData.append('comment', payload.comment)

    const response: IHttpResponse = await this.post(url, formData)
    let data: any
    const authError = new AuthResponseError()
    const state = this.parse<IUserAPIUtilsComplaintResponse>(response)
    if (state.authError) authError.emit(response)
    if (state.success) {
      data = state.responseData
    }

    return {
      ...state,
      data,
    }
  }
}

export const userReportApi = new UserReportApi()
